'use client';

import React from 'react';
import { Breadcrumb, Card, Heading, BREADCRUMB_ITEMS } from '@ui';
import { withOptionalId } from '@lib/withOptionalId';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface BreadcrumbsDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const BreadcrumbsDemo: React.FC<BreadcrumbsDemoProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  const breadcrumbItems = isSpanish
    ? [
        { label: 'Inicio', href: '#' },
        { label: 'Proceso de desarrollo', href: '#' },
        { label: 'Descubrimiento', isCurrent: true },
      ]
    : BREADCRUMB_ITEMS;

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{t('Breadcrumbs', 'Migas de pan (Breadcrumbs)')}</Heading>
        <p className='sub full'>
          {t(
            'Context navigation with separators and responsive overflow.',
            'Navegacion contextual con separadores y desplazamiento responsive.'
          )}
        </p>
        <Card>
          <Breadcrumb items={breadcrumbItems} />
        </Card>
        <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<nav class="card breadcrumbs" aria-label="Breadcrumb">
  <ol class="crumbs">
    <li><a href="/">Home</a></li>
    <li><span aria-current="page">Current</span></li>
  </ol>
</nav>`}
        />
      </Container>
    </Section>
  );
};

export default BreadcrumbsDemo;
